module.exports = __webpack_public_path__ + "img/hardwareClose.bb7e53ce.png";